import React from 'react';
import proptypes from 'prop-types';
import { RatingMeter } from '@one-thd/sui-atomic-components';

const { number, string } = proptypes;

export const RatingsAndReviewsMobileHeader = (props) => {
  const { average, total, recommendationPercentage } = props;
  return (
    <div className="ratings-and-reviews-overview__mobile-header">
      <div className="ratings-and-reviews-overview__mobile-rating-details">
        <span className="ratings-and-reviews-overview__mobile-average">{average} </span>
        <div className="ratings-and-reviews-overview__mobile-total-wrapper">
          <RatingMeter
            className="sui-p-0 sui-justify-start"
            value={average}
            RatingProps={{
              color: 'brand'
            }}
          />
          <span className="ratings-and-reviews-overview__mobile-total">
            {`out of ${total} reviews`}
          </span>
        </div>
      </div>
      <div className="ratings-and-reviews-overview__mobile-recommend">
        <span className="u__bold">{recommendationPercentage}%</span>
        {' Recommend'}
      </div>
    </div>
  );
};

RatingsAndReviewsMobileHeader.propTypes = {
  average: number.isRequired,
  total: number.isRequired,
  recommendationPercentage: string
};

RatingsAndReviewsMobileHeader.defaultProps = {
  recommendationPercentage: ''
};

RatingsAndReviewsMobileHeader.displayName = 'RatingsAndReviewsMobileHeader';
